export { default } from './SimpleSlider';
